import Vue from 'vue'

import {
  Style,
  Button,
  Toast,
  Radio,
  Floating,
  Tag,
  Badge,
  ParaText,
  NoticeBar,
  Loading,
  Dialog,
  Input,
  Select,
  Checkbox,
  LoadList,
  Switch,
  Popup,
  BetterScroll,
} from '@didi/go-design-mobile-vue'
// go-design-mobile-vue 样式
import '@didi/go-design-mobile-vue/lib/style.css'
// 全局loading
import globalLoading from '@/common/components/global-loading/index.js'

Vue.prototype.$globalLoading = globalLoading

Vue.use(Style)
Vue.use(Button)
Vue.use(Toast)
Vue.use(Radio)
Vue.use(Floating)
Vue.use(Tag)
Vue.use(Badge)
Vue.use(ParaText)
Vue.use(NoticeBar)
Vue.use(Loading)
Vue.use(Dialog)
Vue.use(Input)
Vue.use(Select)
Vue.use(Checkbox)
Vue.use(LoadList)
Vue.use(Switch)
Vue.use(Popup)
// Vue.use(BetterScroll)
